<template>
  <tabs parent="remote_sim">

    <tab id="remote_sim_list" name="Remote Sim List" :href="url+'remote_sim_list'"
      :is-visible="isTabVisible('remote_sim_list')" >
      <RemoteSimsList />
    </tab>

    <tab id="sim_readers" name="Sim Readers" :href="url+'sim_readers'"
      :is-visible="isTabVisible('sim_readers')" >
      <SimReaders />
    </tab>

    <tab id="sim_servers" name="Sim Servers" :href="url+'sim_servers'"
      :is-visible="isTabVisible('sim_servers')" >
      <SimServers />
    </tab>

    <tab id="client_settings" name="Clients settings" :href="url+'client_settings'"
      :is-visible="isTabVisible('client_settings')" >
      <ClientSettings />
    </tab>

  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import SimReaders from './Tabs/SimReaders/Index.vue'
import SimServers from './Tabs/SimServers/Index.vue'
import RemoteSimsList from './Tabs/RemoteSimList/Index.vue'
import ClientSettings from './Tabs/ClientSettings/Index.vue'

export default {
  name: 'RemoteSim',
  components:{
    Tab,
    Tabs,
    SimReaders,
    SimServers,
    RemoteSimsList,
    ClientSettings,

  },
  props: {
    dev_id: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      load: true,
      simcards: [],
      tariffs: [],
    }
  },

  computed: {
    url () { return '/remote_sim/' }
  },

  methods: {
    isTabVisible(tab) {
      switch(tab) {
        case 'remote_sim_list': return (this.$store.getters.getPermissions?.controlRemoteSim === true);
        case 'sim_readers': return (this.$store.getters.getPermissions?.controlRemoteSim === true);
        case 'sim_servers': return (this.$store.getters.getPermissions?.permissionGod === true);
        case 'client_settings': return (this.$store.getters.getPermissions?.permissionGod === true);
      }
      return false;
    },
  }

}
</script>
